import { useMemo } from 'react';
import { mainMenuItems, orgMigrationMenuItem } from './utils/utils';
import { appRoutes } from '../../../constants/appRoutes';
import { MainMenuItem } from './utils/types';
import { useSelector } from 'react-redux';
import { selectIsDisableAi } from '../../../reducers/userInfoReducer';
import { selectDefaultCreationEnvironment } from '../../pages/environments/environmentsReducer';
import { SNOWFLAKE_ALLOWED_ROUTES } from '../../../constants/snowflakeConstants';
import { useFeatureToggle } from '../../../feature-flags/useFeatureToggle';

export const useMenuItemsWithPermissions = (): MainMenuItem[] => {
  const isDisableAi = useSelector(selectIsDisableAi);
  const defaultCreationEnv = useSelector(selectDefaultCreationEnvironment);
  const isSnowflakeEnv = defaultCreationEnv?.orgType === 'snowflake';

  const { orgMigrationDemo } = useFeatureToggle();


  const menuItemsWithPermissions = useMemo(() => {
    return mainMenuItems.map((item) => {

      if (item.route === appRoutes.agenticLayer.route) {
        return {
          ...item,
          isHidden: isDisableAi,
        };
      }

      if (isSnowflakeEnv) {
        return {
          ...item,
          isHidden: !SNOWFLAKE_ALLOWED_ROUTES.includes(item.route),
        };
      }
      if (orgMigrationDemo && item.route === 'apps1') {
        // Guard against menuColumns possibly being undefined
        return {
          ...item,
          menuColumns: item.menuColumns ? [{
            ...item.menuColumns[0], menuItems: [
              ...item.menuColumns[0].menuItems,
              orgMigrationMenuItem,
            ]
          }] : undefined,
        }
      }

      return item;
    });
  }, [isDisableAi, isSnowflakeEnv, orgMigrationDemo]);

  return menuItemsWithPermissions;
};
